import http from "../api/http";
import { get } from "lodash";

import * as actionType from "./actionType";
import { message } from "antd";
import intl from "react-intl-universal";

import m4 from "@/assets/image/menu/m4.png";
import m4s from "@/assets/image/menu/m4s.png";
import m3 from "@/assets/image/menu/m3.png";
import m3s from "@/assets/image/menu/m3s.png";
import m2 from "@/assets/image/menu/m2.png";
import m2s from "@/assets/image/menu/m2s.png";
import m5 from "@/assets/image/menu/m5.png";
import m5s from "@/assets/image/menu/m5s.png";
import m6 from "@/assets/image/menu/m6.png";
import m6s from "@/assets/image/menu/m6s.png";
import m7 from "@/assets/image/menu/m7.png";
import m7s from "@/assets/image/menu/m7s.png";
import m8 from "@/assets/image/menu/m8.png";
import m8s from "@/assets/image/menu/m8s.png";
import m9 from "@/assets/image/menu/m9.png";
import m9s from "@/assets/image/menu/m9s.png";
import m11 from "@/assets/image/menu/m11.png";
import m11s from "@/assets/image/menu/m11s.png";
import m10 from "@/assets/image/menu/m10.png";
import m10s from "@/assets/image/menu/m10s.png";
const updateInfo = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...data,
      },
    });
  };
};
const getInfo = () => {
  return async (dispatch) => {
    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });

    sessionStorage.setItem("userInfo", JSON.stringify(res.data));
  };
};

const getUserInfo = () => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });
    sessionStorage.setItem("userInfo", JSON.stringify(res.data));
    dispatch({
      type: actionType.UPDATE_MENU_LIST,
      payload: {
        menuList: [
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF001",
          //   children: [

          //   ],
          //   icon: null,
          //   name: intl.get("auth_package_menutitle"),
          //   id: 1,
          //   type: 3,
          //   parentId: 0,
          // },
          {
            path: "",
            component: null,
            code: "EMF346",
            children: [
              {
                path: "/find",
                component: "Find",
                code: "EMY347",
                children: null,
                selectedIcon: m4s,
                unselectedIcon: m4,
                name: intl.get("auth_search_title"),
                id: 4,
                type: 1,
                parentId: 3,
              },
              {
                path: "/raidsys",
                component: "Raidsys",
                code: "EMY372",
                children: null,
                selectedIcon: m10s,
                unselectedIcon: m10,
                name: intl.get("auth_connection_task"),
                id: 72,
                type: 1,
                parentId: 3,
              },
              {
                path: "/list",
                component: "List",
                code: "EMY372",
                children: null,
                selectedIcon: m10s,
                unselectedIcon: m10,
                name: "List",
                id: 73,
                type: 1,
                parentId: 3,
              },
            ],
            icon: null,
            name: intl.get("auth_connection_manage"),
            id: 3,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF346",
            children: [
              {
                path: "/incoming",
                component: "Incoming",
                code: "EMY348",
                children: null,
                selectedIcon: m3s,
                unselectedIcon: m3,
                name: intl.get("auth_my_talents"),
                id: 5,
                type: 1,
                parentId: 6,
              },

              // {
              //   path: "/checklist",
              //   component: "Checklist",
              //   code: "EMY377",
              //   children: null,
              //   selectedIcon: y2,
              //   unselectedIcon: y1,
              //   name: intl.get("auth_checklist_manage"),
              //   id: 77,
              //   type: 1,
              //   parentId: 6,
              // },
              {
                path: "/group",
                component: "userGroup",
                code: "EMY377",
                children: null,
                selectedIcon: m2s,
                unselectedIcon: m2,
                name: intl.get("auth_group_manage"),
                id: 78,
                type: 1,
                parentId: 6,
              },

              {
                path: "/creatorStatus",
                component: "Status",
                code: "EMY377",
                children: null,
                selectedIcon: m2s,
                unselectedIcon: m2,
                name: "Creator Status",
                id: 79,
                type: 1,
                parentId: 6,
              },
              {
                path: "/creativeBriefs",
                component: "Briefs",
                code: "EMY377",
                children: null,
                selectedIcon: m2s,
                unselectedIcon: m2,
                name: "Creative Briefs",
                id: 80,
                type: 1,
                parentId: 6,
              },
              // {
              //   path: "/sample",
              //   component: "Sample",
              //   code: "EMY349",
              //   children: null,
              //   selectedIcon: m5s,
              //   unselectedIcon: m5,
              //   name: intl.get("auth_sample_manage"),
              //   id: 7,
              //   type: 1,
              //   parentId: 6,
              // },
            ],
            icon: null,
            name: intl.get("auth_cooperation"),
            id: 6,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF352",
            children: [
              {
                path: "/scriptLibrary",
                component: "ScriptLibrary",
                code: "EMY352",
                children: null,
                selectedIcon: m6s,
                unselectedIcon: m6,
                name: intl.get("auth_script_library"),
                id: 8,
                type: 1,
                parentId: 3,
              },
              // {
              //   path: "/sendEmail",
              //   component: "SendEmail",
              //   code: "EMY356",
              //   children: null,
              //   selectedIcon: email2,
              //   unselectedIcon: email1,
              //   name: intl.get("auth_send_email"),
              //   id: 9,
              //   type: 1,
              //   parentId: 3,
              // },
              {
                path: "/score",
                component: "ScoreDeploy",
                // component: "ScoreConfig",
                // component: "Score",
                code: "EMY357",
                children: null,
                selectedIcon: m7s,
                unselectedIcon: m7,
                name: intl.get("auth_talent_score_config"),
                id: 11,
                type: 1,
                parentId: 3,
              },
              {
                path: "/shopList",
                component: "ShopList",
                code: "EMY354",
                children: null,
                selectedIcon: m8s,
                unselectedIcon: m8,
                name: intl.get("auth_shop_list"),
                id: 16,
                type: 1,
                parentId: 10,
              },
            ],
            icon: null,
            name: intl.get("auth_ai_assistant"),
            id: 10,
            type: 3,
            parentId: 0,
          },
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF353",
          //   children: [

          //   ],
          //   icon: null,
          //   name: intl.get("auth_shop_manage"),
          //   id: 15,
          //   type: 3,
          //   parentId: 0,
          // },
          {
            path: "",
            component: null,
            code: "EMF330",
            children: [
              {
                path: "/package",
                component: "Package",
                code: "EMY348",
                children: null,
                selectedIcon: m9s,
                unselectedIcon: m9,
                name: intl.get("auth_package_title"),
                id: 2,
                type: 1,
                parentId: 30,
              },
              {
                path: "/order-list",
                component: "OrderList",
                code: "EMY358",
                children: null,
                selectedIcon: m11s,
                unselectedIcon: m11,
                name: intl.get("auth_order_title"),
                id: 31,
                type: 1,
                parentId: 30,
              },
            ],
            icon: null,
            name: intl.get("auth_order_menutitle"),
            id: 30,
            type: 3,
            parentId: 0,
          },
          // {
          //   path: "",
          //   component: null,
          //   code: "EMF357",
          //   children: [
          //     {
          //       path: "/help",
          //       component: "Help",
          //       code: "EMY358",
          //       children: null,
          //       selectedIcon: help2,
          //       unselectedIcon: help1,
          //       name: intl.get("auth_help_center"),
          //       id: 20,
          //       type: 1,
          //       parentId: 15,
          //     },
          //   ],
          //   icon: null,
          //   name: intl.get("auth_more"),
          //   id: 20,
          //   type: 3,
          //   parentId: 0,
          // },
        ],
      },
    });

    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: false },
    });
  };
};

const getEnvCheck = () => {
  return async (dispatch) => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/system/env/check",
    });
    if (res.code === 200) {
      dispatch({
        type: actionType.UPDATE_USER_INFO,
        payload: {
          ...res.data,
        },
      });
    }
  };
};

const changeLoading = (status) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status },
    });
  };
};

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

const login = (obj, errorCallback) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/auth/login",
        data: {
          ...obj,
        },
      });
      if (res.code === 200) {
        if (!get(res, "data.accessToken", "") || "") {
          message.error(intl.get("common_message_tokenError"));
          return;
        }
        let date = new Date();
        date.setTime(date.getTime() + (res?.data?.expiresIn || 3600) * 1000);

        document.cookie = `token=${
          get(res, "data.accessToken", "") || ""
        }; expires=${date.toUTCString()};`;

        if (isMobileDevice()) {
          window.location.href = "/mobileInvite";
        } else {
          if (obj.email === "tianer666@icloud.com") {
            window.location.href = "/find";
            return;
          }
          sessionStorage.setItem("firstNewModal", "1");
          window.location.href = "/envconfig";
        }
      } else {
        errorCallback && errorCallback(res);
      }
    } catch (error) {
      console.log(error);
    }
  };
};

const register = (obj) => {
  return async () => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/auth/register",
      data: {
        ...obj,
      },
    });
    if (res.code === 200) {
      message.success(intl.get("common_message_registrySuccess"));
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }
  };
};

const logout = () => {
  return async () => {
    // const res = await http({
    //   method: 'GET',
    //   url: 'logout',
    //   headers: { urlPrefix: 'login' },
    // });

    // if (res.code === 0) {
    document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    window.location.href = `/login`;
    // }
  };
};

const shopInitialize = () => {
  return async (dispatch) => {
    dispatch(
      updateInfo({
        initializeLoading: true,
      }),
    );
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/rpa-task/shop-initialize",
      });
      if (res.code === 200) {
        //
      }
    } finally {
      // dispatch(
      //   updateInfo({
      //     initializeLoading: false,
      //   })
      // );
    }
  };
};

export {
  login,
  logout,
  getInfo,
  getUserInfo,
  changeLoading,
  register,
  getEnvCheck,
  updateInfo,
  shopInitialize,
};
